// extracted by mini-css-extract-plugin
export default {"root":"ListTabs_root__W5Vyq","tab":"ListTabs_tab__SlzIe","--active":"ListTabs_--active__je-X6"};